const useZendesk = () => {
  const createChatWidget = () => {
    const isZendeskInstantiated = document.getElementById('ze-snippet');

    if (!isZendeskInstantiated && "https://static.zdassets.com/ekr/snippet.js?key=9a46f5c8-0947-4716-a5cd-05541a8d5d52") {
      const zendeskScript = document.createElement('script');
      zendeskScript.src = "https://static.zdassets.com/ekr/snippet.js?key=9a46f5c8-0947-4716-a5cd-05541a8d5d52";
      zendeskScript.id = 'ze-snippet';
      document.getElementById('cwf-body').appendChild(zendeskScript);
    }
  };

  const destroyChatWidget = () => {
    const zendeskWidget = document.getElementById('ze-snippet');

    if (zendeskWidget) {
      zendeskWidget.remove();
    }
  };

  const openChatWidget = () => {
    if (window.zE) {
      window.zE('messenger', 'open');
    }
  };

  const getUnreadChatMessages = cb => {
    if (window.zE) {
      window.zE('messenger:on', 'unreadMessages', cb);
    }
  };

  return {
    createChatWidget,
    destroyChatWidget,
    openChatWidget,
    getUnreadChatMessages
  };
};

export default useZendesk;
